'use strict';
require('../../../modules/es.array.reduce');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'reduce');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/reduce.js
// module id = 562
// module chunks = 13